export const AGENT_TABLE_COLUMNS_STORAGE_KEY = "callpanel.agentTableColumns.v1";

export const AGENT_TABLE_COLUMN_DEFS = [
  { key: "kullanici_adi", label: "Kullanıcı adı", defaultVisible: true },
  { key: "company", label: "Firma", defaultVisible: true, superAdminOnly: true },
  { key: "gsm", label: "GSM", defaultVisible: true },
  { key: "team", label: "Takım", defaultVisible: true },
  { key: "team_leader", label: "Takım lideri", defaultVisible: true },
  { key: "ise_giris_tarihi", label: "İşe giriş", defaultVisible: true },
  { key: "isten_cikis_tarihi", label: "İşten çıkış", defaultVisible: true },
  { key: "yeni_dataya_gecis_tarihi", label: "Yeni dataya geçiş", defaultVisible: false },
  { key: "devices", label: "Cihaz", defaultVisible: true },
  { key: "token", label: "Token", defaultVisible: true },
  { key: "status", label: "Durum", defaultVisible: true },
  { key: "yetki", label: "Yetki", defaultVisible: true },
];

export function loadAgentTableColumns() {
  const defaults = {};
  AGENT_TABLE_COLUMN_DEFS.forEach((c) => { defaults[c.key] = c.defaultVisible; });
  try {
    const raw = localStorage.getItem(AGENT_TABLE_COLUMNS_STORAGE_KEY);
    if (!raw) return defaults;
    const parsed = JSON.parse(raw);
    return { ...defaults, ...parsed };
  } catch {
    return defaults;
  }
}

export function saveAgentTableColumns(cols) {
  try {
    localStorage.setItem(AGENT_TABLE_COLUMNS_STORAGE_KEY, JSON.stringify(cols));
  } catch {
    /* ignore */
  }
}
